import { ListItem, ListItemButton, SvgIcon, SxProps, Theme } from '@mui/material';
import React from 'react';
import getMuiIcon from '../../../utils/getMuiIcon';
import { palette } from '../../../assets/styles/themes/tokens';

interface MuLogoProps {
  onClick: () => void;
  variant?: 'full' | 'small';
  sx?: SxProps<Theme>;
}

const interactionStyles = {
  '&:hover': {
    backgroundColor: palette.primary.selected,
  },
  '&:focus': {
    backgroundColor: 'transparent',
    outline: 'none',
  },
  '&:focus:hover': {
    backgroundColor: palette.primary.selected,
  },
  '&:active': {
    backgroundColor: palette.common.white,
  }
};

const MuLogo = ({ onClick, variant = 'full', sx = {} }: MuLogoProps) => {
  const isFull = variant === 'full';
  const logoProps = isFull 
    ? {
      width: '128px',
      height: '20px',
      viewBox: '0 0 128 20',
    }
    : {
      width: '32px',
      height: '32px',
      viewBox: '0 0 32 32',
    };

  return (
    <ListItem disablePadding>
      <ListItemButton
        data-testid={isFull ? 'logo-button-full' : 'logo-button-small'}
        onClick={onClick}
        sx={{
          ...interactionStyles,
          ...sx,
        }}
      >
        <SvgIcon
          sx={{ 
            width: logoProps.width, 
            height: logoProps.height,
            color: palette.primary.main 
          }}
          component={getMuiIcon(isFull ? 'muLogoFull' : 'muLogoBag')}
          viewBox={logoProps.viewBox}
        /> 
      </ListItemButton>
    </ListItem>
  );
};

export default MuLogo;
